module.exports = __webpack_public_path__ + "static/img/qietu02.ccc70b2.png";


//////////////////
// WEBPACK FOOTER
// ./static/imgV2/qietu02.png
// module id = SFDF
// module chunks = 1